/* eslint-disable no-undef */
import Modal from 'react-bootstrap/Modal';
import { Dispatch, SetStateAction } from 'react';
import Slider from 'react-slick';

interface Props {
  isVisible: boolean;
  setIsVisible: Dispatch<SetStateAction<boolean>>;
}
const setting = {
  dots: true,
  infinite: true,
  speed: 800,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: false,
};
function Instruct({ isVisible, setIsVisible }: Props) {
  const onClose = () => setIsVisible(false);
  const listImg = [
    '/static/img/guide-1.jpg',
    '/static/img/guide-2.jpg',
    '/static/img/guide-3.jpg',
    '/static/img/guide-4.jpg',
  ];
  return (
    <Modal
      className="modal-instruct"
      show={isVisible}
      onHide={onClose}
      centered
    >
      <div className="close" onClick={onClose}>
        <i className="fa-solid fa-xmark"></i>
      </div>
      <Slider {...setting}>
        {listImg.map((item, i) => (
          <div className="--item" key={i}>
            <img src={item} alt="" />
          </div>
        ))}
      </Slider>
    </Modal>
  );
}
export default Instruct;
